import type { Location } from "react-router-dom";

const KEY = "chronos.returnTo";

/** Only a path of this app: never an absolute URL handed over by a link. */
const isLocalPath = (value: string) =>
	value.startsWith("/") && !value.startsWith("//");

/** The page a signed-out visit was after (`state.from` of the login redirect). */
export const returnToOf = (location: Location): string | undefined => {
	const from = (location.state as { from?: Location } | null)?.from;
	if (!from?.pathname) return undefined;
	const path = from.pathname + (from.search ?? "") + (from.hash ?? "");
	return isLocalPath(path) && path !== "/login" ? path : undefined;
};

/**
 * Kept across the SSO round trip (the provider's page loses the router
 * state): written when the login page is opened for a page, read - and
 * forgotten - once the callback has signed the user in.
 */
export const rememberReturnTo = (path: string | undefined) => {
	if (!path) return;
	try {
		window.sessionStorage.setItem(KEY, path);
	} catch {
		// Storage unavailable: the user lands on "/".
	}
};

export const takeReturnTo = (): string => {
	try {
		const path = window.sessionStorage.getItem(KEY);
		window.sessionStorage.removeItem(KEY);
		return path && isLocalPath(path) ? path : "/";
	} catch {
		return "/";
	}
};
